import { AxiosInstance, AxiosRequestConfig } from "axios";

import { AxiosInstanceInterceptorRequestExtensionI } from "@/api/interceptors/interface";

/**
 * The caller's Top 10 (C-16 S4, GLE-8411): up to 10 nurtures they never want
 * to lose. Every route is behind the backend switch `top_ten_enabled`: while
 * it is off no route is registered and each answers 404 (error_code 1035),
 * which the app reads as "Top 10 is not switched on".
 */

export interface TopTenAccountI {
  campaign_id: string;
  account_id: string;
}

export interface GetTopTenResponseI {
  limit: number;
  items: Array<TopTenAccountI>;
}

export interface AddToTopTenRequestI {
  /** The call-by time (ISO): it becomes the lead's callback. */
  follow_up_time: string;
  notes?: string;
  /** Defaults to the lead's last contact. */
  contact_id?: string;
}

/** A 404 here means "switched off": an answer, not an error to log. */
const switchProbeConfig = (): AxiosRequestConfig &
  AxiosInstanceInterceptorRequestExtensionI => ({
  meta: { expectedStatuses: [404] },
});

const topTenPath = (campaignId: string, accountId: string) =>
  `/v1/campaign/${encodeURIComponent(campaignId)}/account/${encodeURIComponent(
    accountId
  )}/top_ten`;

export const TopTenAPIEndpoints = (api: AxiosInstance) => ({
  getTopTen: () =>
    api.get<GetTopTenResponseI>("/v1/top_ten", { ...switchProbeConfig() }),

  addToTopTen: (
    campaignId: string,
    accountId: string,
    body: AddToTopTenRequestI
  ) => api.post(topTenPath(campaignId, accountId), body),

  removeFromTopTen: (campaignId: string, accountId: string) =>
    api.delete(topTenPath(campaignId, accountId)),
});
